
function checkDelivery(pickup_postcode,delivery_postcode,cod,weight) {
  
  $('#check_zip_code').val('Checking...');
	var settings = {
	  "url": "https://www.blueclub.in/shopify/bcsreturn-shiprocketapi.php",
	  "method": "POST",
	  "timeout": 0,
	  "headers": {
	    "Content-Type": "application/json"
	  },
	  "data": JSON.stringify({
	    "action": 'auth'
	    }),
	};

	
	$.ajax(settings).done(function (response) {
       
	   //alert(JSON.stringify(response));
      
       response = jQuery.parseJSON(response);
            
	   var token = response.token;
            
      
	   if(token != ''){
         			
         
			checkServicibility(token,pickup_postcode,delivery_postcode,cod,weight)
	
           } else {
             
             $('#check_zip_code').val('check');
             
		     return "Invalid Token";
	   }
          
	});
}

function  checkServicibility(token,pickup_postcode,delivery_postcode,cod,weight) {

  
	var urlval = "?pickup_postcode="+pickup_postcode+"&delivery_postcode="+delivery_postcode+"&cod="+cod+"&weight="+weight;

	var settings = {
	  	  
      "url": "https://www.blueclub.in/shopify/bcsreturn-shiprocketapi.php"+urlval,
	  "method": "GET",
	  "timeout": 0,
	  "headers": {
	    "Content-Type": "application/json",
	    "Authorization": "Bearer "+token
	  },
	};

	$.ajax(settings).done(function (response) {
      
           
      	response = jQuery.parseJSON(response);
      
      
		if(response.status==200) {
			
			$("#check_status").text("We deliver in your area! "+delivery_postcode+"");
                	$("#check_status").css("color","green")
		}else{ 
			$("#check_status").text("We do not deliver in your area! "+delivery_postcode+"");
                	$("#check_status").css("color","red")
		}
	}).fail(function() {
		$("#check_status").text("We do not deliver in your area! "+delivery_postcode+"");
                	$("#check_status").css("color","red");	  

	});
  
  $('#check_zip_code').val('check');

	
}

$(document).ready(function(){

	$("#zip_value").keypress(function (e) {
            var keyCode = e.keyCode || e.which;
 
            $("#check_status").text("");

 
            //Regex for Valid Characters i.e. Numbers.
            var regex = /^[0-9]+$/;
 
            //Validate TextBox value against the Regex.
            var isValid = regex.test(String.fromCharCode(keyCode));
      
            if (!isValid) {
              
                $("#check_status").text("Only Numbers allowed.");
				$("#check_status").css("color","black");
            }
 
            return isValid;
        });

	$("#check_zip_code").click(function(){
		     
	  var zip_code=$("#zip_value").val();

	  if(zip_code==""){
                $("#check_status").text("Please write the correct zip code !");
                $("#check_status").css("color","black")
         }
         else{
		 checkDelivery(360001,zip_code,1,1);
        // var token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjE1MjczMDMsImlzcyI6Imh0dHBzOi8vYXBpdjIuc2hpcHJvY2tldC5pbi92MS9leHRlcm5hbC9hdXRoL2xvZ2luIiwiaWF0IjoxNjI1NDcwNzg2LCJleHAiOjE2MjYzMzQ3ODYsIm5iZiI6MTYyNTQ3MDc4NiwianRpIjoiblZkOG9CTjQwb2xySXIwNiJ9.T7ITCQ72h-e0pZy3KtElQAZsWKsbjuj8dVEB143b3Mc";
        // checkServicibility(token,360001,zip_code,1,1);
	 }

  });

});